import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

// The row's own controls keep their clicks.
const CONTROLS =
  "a, button, input, select, textarea, label, summary, [role='button'], [role='checkbox'], [role='switch'], [role='menuitem'], [role='tab']";

// Whether a click on a clickable row or card (event.currentTarget) should open it: not a click on one of
// its own links, buttons or checkboxes, and not the end of a text selection inside it.
export function isOpenClick(event) {
  if (event.defaultPrevented) return false;
  const row = event.currentTarget;
  const control = event.target instanceof Element ? event.target.closest(CONTROLS) : null;
  if (control && control !== row && row.contains(control)) return false;
  const selection = window.getSelection?.();
  return !(selection && !selection.isCollapsed && row.contains(selection.anchorNode));
}

// Click handlers that open `to` from a whole row or card the way a link would: Ctrl/Cmd or middle click
// opens it in a new tab. The row still needs a real link or button inside it for keyboard users.
export function useRowLink() {
  const navigate = useNavigate();
  return useCallback(
    (to, { state, onOpen } = {}) => {
      const open = (event) => {
        if (!isOpenClick(event)) return;
        onOpen?.();
        if (event.button === 1 || event.ctrlKey || event.metaKey) window.open(to, "_blank", "noopener");
        else navigate(to, state ? { state } : undefined);
      };
      return {
        onClick: open,
        onAuxClick: (event) => {
          if (event.button === 1) open(event);
        },
      };
    },
    [navigate]
  );
}
